window.DeskomaTheme = {}
DeskomaTheme.initWhenVisible = function(options) {
    const threshold = options.threshold ? options.threshold : 0;
    new IntersectionObserver( (entries, observer2) => {
        entries.forEach(entry => {
            entry.isIntersecting && typeof options.callback == "function" && (options.callback(),
            observer2.unobserve(entry.target))
        }
        )
    }
    ,{
        rootMargin: `0px 0px ${threshold}px 0px`
    }).observe(options.element)
}


class VideoComponent extends HTMLElement {
    constructor() {
        super(),
        DeskomaTheme.initWhenVisible({
            element: this,
            callback: this.init.bind(this),
            threshold: 0
        });
    }
    init() {
        this.autoPlay = this.dataset.autoPlay === "true",
        this.muted = this.dataset.muted === "true",
        this.focus = this.dataset.focus === "true";
        const poster = this.querySelector('[id^="Video-Deferred-Poster-"]');
        this.autoPlay ? this.loadContent() : poster && poster.addEventListener("click", this.loadContent.bind(this)),
        this.focus && this.videoPlay()
    }
    loadContent() {
        if (!this.getAttribute("loaded")) {
            const content = document.createElement("div");
            content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)),
            this.setAttribute("loaded", !0);
            const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
            if (this.deferredElement = deferredElement,
            this.autoPlay)
                return;
            if (this.deferredElement.classList.contains("js-youtube")) {
                const symbol = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
                this.deferredElement.src += symbol + `autoplay=1${this.muted ? "&mute=1" : ""}`
            } else if (this.deferredElement.classList.contains("js-vimeo")) {
                const symbol = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
                this.deferredElement.src += symbol + `autoplay=1${this.muted ? "&mute=1" : ""}`
            } else
                this.deferredElement.play()
        }
    }
    videoPlay() {
        const deferredElement = this.appendChild(this.querySelector("video"));
        deferredElement && deferredElement.addEventListener("mouseenter", function() {
            deferredElement.play()
        }),
        deferredElement && deferredElement.addEventListener("mouseleave", function() {
            deferredElement.pause()
        })
    }
};
customElements.define("video-component", VideoComponent);

function queryDomNodes(selectors = {}, context = document) {
  const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
    const findOne = typeof selector === "string";
    const queryMethod = findOne ? "querySelector" : "querySelectorAll";
    const sl = findOne ? selector : selector[0];

    if (context) {
      acc[name] = context[queryMethod](sl);
    }
    if (!findOne && acc[name]) {
      acc[name] = [...acc[name]];
    }
    return acc;
  }, {});
  return domNodes;
}

class CountdownTimer {
  constructor(container, startTime, endTime, options = {}) {
    this.times = ["day", "hour", "min", "sec"];
    this.selectors = {
      day: ".countdown-timer-day",
      hour: ".countdown-timer-hour",
      min: ".countdown-timer-minute",
      sec: ".countdown-timer-sec",
    };
    this.DAY_IN_MS = 24 * 60 * 60 * 1000;
    this.HOUR_IN_MS = 60 * 60 * 1000;
    this.MIN_IN_MS = 60 * 1000;

    this.container = container;
    this.startTime = startTime;
    this.savedStartTime = startTime;
    this.endTime = endTime;
    this.options = Object.assign(
      {},
      {
        addZeroPrefix: true,
        loop: false,
        callback: () => { },
      },
      options
    );

    this.intervalTime = 1000;
    this.timer = null;
    this.domNodes = queryDomNodes(this.selectors, container);

    this.start();
  }

  start() {
    this.timer = setInterval(() => {
      if (this.startTime > this.endTime) this.stop();
      else this.update();
    }, this.intervalTime);

    this.container.style.removeProperty("opacity");
  }

  update() {
    const timeData = this.format(this.endTime - this.startTime);
    this.times.forEach((time) => {
      if (this.domNodes[time]) {
        this.domNodes[time].textContent = this.addZeroPrefix(timeData[time]);
      }
    });
    this.startTime += this.intervalTime;
  }

  stop() {
    clearInterval(this.timer);
    if (this.options.loop) {
      this.startTime = this.savedStartTime;
      this.start();
    } else {
      this.timer = null;
      this.options.callback();
    }
  }

  clear() {
    clearInterval(this.timer);
    this.timer = null;
    this.startTime = this.savedStartTime;
    this.times.forEach((time) => {
      if (this.domNodes[time]) {
        this.domNodes[time].textContent = "00";
      }
    });
  }

  addZeroPrefix(num) {
    if (this.options.addZeroPrefix && num < 10) {
      return `0${num}`;
    }
    return num.toString();
  }

  format(ms) {
    return {
      day: Math.floor(ms / this.DAY_IN_MS),
      hour: Math.floor(ms / this.HOUR_IN_MS) % 24,
      min: Math.floor(ms / this.MIN_IN_MS) % 60,
      sec: Math.floor(ms / 1000) % 60,
    };
  }
}
window.DeskomaTheme.CountdownTimer = CountdownTimer;